<template>
  <v-app-bar app color="primary" dark flat :clipped-left="$vuetify.breakpoint.lgAndUp">
    <v-icon large>mdi-run</v-icon>
    <v-toolbar-title>Yokkame</v-toolbar-title>
    <v-spacer />
    <v-text-field
      clear-icon="mdi-close-circle"
      clearable
      dense
      filled
      hide-details
      label="ユーザー・グループを検索（空白で全件検索ができます）"
      rounded
      :append-icon="'mdi-magnify'"
      v-model="globalSearchWord"
      @click:append="globalSearch()">
    </v-text-field>
    <v-spacer />
  </v-app-bar>
</template>

<script>
import { mapActions } from "vuex";

export default {

  data: () => ({
    toGlobalSearchResultFlag: 0,
    globalSearchWord: "",
  }),

  methods: {
    ...mapActions(["setGlobalSearchWord", "setLoading", "group/fetchGroups", "user/fetchUsers"]),
    // グローバル検索を実施
    async globalSearch() {
      this.setLoading(true);
      this.setGlobalSearchWord(this.globalSearchWord);
      await this["group/fetchGroups"]();
      await this["user/fetchUsers"]();
      this.toGlobalSearchResult();
    },
    toGlobalSearchResult() {
      // 再検索の場合はグローバル検索結果画面の再マウントを実行
      this.$router.currentRoute.name === "GlobalSearchResult" ? this.$emit("rerender")
                                                              : this.$router.push("/global_search_result");
    }
  },

};
</script>
